import axios from 'axios'
import {getAdminToken} from '../../auth/_requests'
import {LoggedOutProfilesResponse, WhatsappAccountsResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const BASE = `${API_URL}/admin/logged-out-profiles`

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`
  return config
})

export function getLoggedOutProfiles(q = ''): Promise<{data: LoggedOutProfilesResponse}> {
  return adminApi.get(BASE, {params: q ? {q} : {}})
}

export function getWhatsappAccounts(): Promise<{data: WhatsappAccountsResponse}> {
  return adminApi.get(`${BASE}/whatsapp`)
}

export function addWhatsapp(): Promise<{data: any}> {
  return adminApi.post(`${BASE}/whatsapp/add`, {})
}

export function reconnectWhatsapp(accountId: string): Promise<{data: any}> {
  return adminApi.post(`${BASE}/whatsapp/${accountId}/reconnect`, {})
}

export function logoutWhatsapp(accountId: string): Promise<{data: any}> {
  return adminApi.post(`${BASE}/whatsapp/${accountId}/logout`, {})
}

export function removeWhatsapp(accountId: string): Promise<{data: any}> {
  return adminApi.post(`${BASE}/whatsapp/${accountId}/remove`, {})
}

export function setAutoSend(enabled: boolean): Promise<{data: any}> {
  return adminApi.post(`${BASE}/auto-send`, {enabled})
}

export function setSmsAutoSend(enabled: boolean): Promise<{data: any}> {
  return adminApi.post(`${BASE}/sms-auto-send`, {enabled})
}

export function sendLoginLink(
  id: string, phone: string, message?: string, attachImage = true, channel: 'whatsapp' | 'sms' = 'whatsapp'
): Promise<{data: any}> {
  return adminApi.post(`${BASE}/${id}/send-login-link`, {phone, channel, message, attach_image: attachImage})
}

export function getSmsStatus(): Promise<{data: {configured: boolean; from: string}}> {
  return adminApi.get(`${BASE}/sms-status`)
}

export function sendSmsBulk(ids: string[], template?: string): Promise<{data: {sent: number; failed: number; total: number}}> {
  return adminApi.post(`${BASE}/send-sms-bulk`, {ids, template})
}

export function sendTestSms(phone: string, message?: string): Promise<{data: any}> {
  return adminApi.post(`${BASE}/send-test-sms`, {phone, message})
}

export function sendTestWhatsapp(phone: string, message?: string, attachImage = true): Promise<{data: any}> {
  return adminApi.post(`${BASE}/send-test-whatsapp`, {phone, message, attach_image: attachImage})
}

export function excludeAccount(accountId: string, excluded: boolean): Promise<{data: any}> {
  return adminApi.post(`${BASE}/exclude-account`, {account_id: accountId, excluded})
}

export function sendPhoto(id: string, phone: string): Promise<{data: any}> {
  return adminApi.post(`${BASE}/${id}/send-photo`, {phone})
}

export function sendPhotoBulk(ids: string[]): Promise<{data: {sent: number; failed: number; total: number}}> {
  return adminApi.post(`${BASE}/send-photo-bulk`, {ids})
}

export function showQr(id: string): Promise<{data: any}> {
  return adminApi.post(`${BASE}/${id}/show-qr`, {})
}
